<div class='slick-tab btn' [ngClass]="{'btn-primary': selected === true, 'btn-secondary': selected === false }" (click)='onTabClicked()'>
	<slick-tab-header *ngIf='showHeaderFromInput' #tabHeaderRef></slick-tab-header>
	<ng-content *ngIf='!showHeaderFromInput' select='slick-tab-header'></ng-content>
</div>
<div id='tabBody_{{uuid}}' class='slick-tab-body' style='display: none; width: 100%;' #tabBodyRef>
	<ng-content></ng-content>
</div>
